import Icon from "@ant-design/icons";
import { useSelector } from "react-redux";

const MessageEditIconSVG = (props) => {
  const themeDefault = useSelector((state) => state.themeDefault);
  let themeValue = themeDefault?.info?.newConfig;
  const predefinedSizes = {
    small: { ...themeValue?.fontSmlSize?.size },
    medium: { ...themeValue?.fontMediumSize?.size },
    large: { ...themeValue?.fontLgSize?.size },
  };
  const { size, width, height } = props;
  const finalSize = predefinedSizes[size] || { width, height };
  return (
    <svg
      width={finalSize?.width ?? "24"}
      height={finalSize?.height ?? "24"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6667 15.1668H2.00001C1.36001 15.1668 0.833344 14.6402 0.833344 14.0002V5.3335C0.833344 2.38683 2.38668 0.833496 5.33334 0.833496H10.6667C13.6133 0.833496 15.1667 2.38683 15.1667 5.3335V10.6668C15.1667 13.6135 13.6133 15.1668 10.6667 15.1668ZM5.33334 1.8335C2.94668 1.8335 1.83334 2.94683 1.83334 5.3335V14.0002C1.83334 14.0935 1.90668 14.1668 2.00001 14.1668H10.6667C13.0533 14.1668 14.1667 13.0535 14.1667 10.6668V5.3335C14.1667 2.94683 13.0533 1.8335 10.6667 1.8335H5.33334Z"
        fill="currentColor"
      />
      <path
        d="M5.29984 11.8335C4.98651 11.8335 4.69984 11.7202 4.48651 11.5135C4.23317 11.2602 4.11983 10.9002 4.17983 10.5135L4.36649 9.19349C4.40649 8.90682 4.5865 8.54016 4.79317 8.33349L8.25317 4.87349C9.43984 3.68682 10.4732 4.22016 11.1265 4.87349C11.6398 5.38682 11.8732 5.92682 11.8198 6.46682C11.7798 6.90682 11.5465 7.32016 11.1265 7.74682L7.6665 11.2068C7.45983 11.4135 7.09983 11.5935 6.80649 11.6402L5.48651 11.8268C5.42651 11.8268 5.35984 11.8335 5.29984 11.8335ZM9.6865 5.16682C9.43983 5.16682 9.21984 5.32682 8.96651 5.57349L5.50651 9.03349C5.45317 9.08682 5.37317 9.25349 5.35984 9.32682L5.17317 10.6468C5.16651 10.7135 5.17316 10.7735 5.19982 10.8002C5.22649 10.8268 5.2865 10.8335 5.35317 10.8268L6.67317 10.6402C6.75317 10.6268 6.91317 10.5468 6.96651 10.4935L10.4265 7.03349C10.6798 6.78016 10.8132 6.56016 10.8332 6.36016C10.8532 6.13349 10.7198 5.86682 10.4265 5.57349C10.1332 5.29349 9.89983 5.16682 9.6865 5.16682Z"
        fill="currentColor"
      />
      <path
        d="M10.2799 8.38681C10.2332 8.38681 10.1866 8.38014 10.1466 8.36681C8.93988 8.02681 7.97322 7.06681 7.63322 5.85347C7.55989 5.58681 7.71322 5.31347 7.97988 5.23347C8.24655 5.16014 8.51989 5.31347 8.59323 5.58014C8.83989 6.45347 9.53988 7.15347 10.4132 7.40014C10.6799 7.47347 10.8332 7.75347 10.7599 8.02014C10.6999 8.24014 10.4999 8.38681 10.2799 8.38681Z"
        fill="currentColor"
      />
    </svg>
  );
};
const MessageEditIcon = (props) => {
  const themeDefault = useSelector((state) => state.themeDefault);
  let themeValue = themeDefault?.info?.newConfig;
  const { size, color } = props;
  const predefinedSizes = {
    small: themeValue?.fontSmlSize,
    medium: themeValue?.fontMediumSize,
    large: themeValue?.fontLgSize,
  };
  return (
    <Icon
      component={MessageEditIconSVG}
      style={{
        // color: color || themeDefault?.info?.newConfig?.color,

        fontSize: predefinedSizes[size] || predefinedSizes.medium,
      }}
      {...props}
    />
  );
};

export default MessageEditIcon;
